var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9602 22.8148V28.9765H24.5301V23.2265C24.5301 21.7831 24.034 20.7981 22.7919 20.7981C21.8444 20.7981 21.2794 21.4615 21.0313 22.1048C20.9417 22.3348 20.9177 22.6548 20.9177 22.9748V28.9765H17.486C17.486 28.9765 17.5325 19.2398 17.486 18.2315H20.9177V19.7531L20.8952 19.7881H20.9177V19.7531C21.3738 19.0198 22.1869 17.9781 24.01 17.9781C26.2668 17.9781 27.9602 19.5148 27.9602 22.8148ZM13.896 13.0498C12.7227 13.0498 11.9545 13.8531 11.9545 14.9065C11.9545 15.9398 12.7003 16.7648 13.8511 16.7648H13.8736C15.0708 16.7648 15.815 15.9381 15.815 14.9065C15.7926 13.8531 15.0708 13.0498 13.896 13.0498ZM12.1577 28.9765H15.5894V18.2315H12.1577V28.9765Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9573 34.2649C23.3533 34.2649 26.6102 32.8601 29.0115 30.3596C31.4128 27.8592 32.7618 24.4678 32.7618 20.9316C32.7618 17.3953 31.4128 14.004 29.0115 11.5035C26.6102 9.00298 23.3533 7.59823 19.9573 7.59823C16.5613 7.59823 13.3044 9.00298 10.9031 11.5035C8.50179 14.004 7.15274 17.3953 7.15274 20.9316C7.15274 24.4678 8.50179 27.8592 10.9031 30.3596C13.3044 32.8601 16.5613 34.2649 19.9573 34.2649ZM19.9573 37.5982C11.1173 37.5982 3.9516 30.1366 3.9516 20.9316C3.9516 11.7266 11.1173 4.26489 19.9573 4.26489C28.7972 4.26489 35.963 11.7266 35.963 20.9316C35.963 30.1366 28.7972 37.5982 19.9573 37.5982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4840ae7c4e407e3df305c0f4ff01218c.svg";
export { ForwardRef as ReactComponent };